<script setup lang="ts">
import { computed } from 'vue'

import type {
  ContentHeadingRootProps,
  Heading,
  HeadlineLevel,
} from '@fondof-ui/components/content/types'
import type { HTMLAttributeClass } from '@fondof-ui/types'

const props = defineProps<ContentHeadingRootProps & HTMLAttributeClass>()

const headlineLevel = computed(() => {
  return props.headlineLevel ?? 2
})

const headlineElement = computed<Heading>(() => `h${headlineLevel.value}`)

const sublineElement = computed<Heading>(() => {
  return `h${(Number(headlineLevel.value) < 6 ? Number(headlineLevel.value) + 1 : 6).toString() as HeadlineLevel}`
})
</script>

<template>
  <div :class="props.class">
    <slot
      :headline-element="headlineElement"
      :subline-element="sublineElement"
    />
  </div>
</template>
